import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { PartiesComponent } from '../parties/parties.component';
import { ePartyType, Order, OrderManagerService, PartiesListComponent, Party, PartyRepositoryService, UIConfigurationService, Utilities, ValidationProblem, ValidationService } from 'reg-hub-common';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';

@Component({
    selector: 'app-peps-and-sanctions-parties',
    templateUrl: './peps-and-sanctions-parties.component.html',
    styleUrl: './peps-and-sanctions-parties.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PepsAndSanctionsPartiesComponent extends PartiesComponent {
  @ViewChild(PartiesListComponent) partiesListComponent!: PartiesListComponent;

  protected businessPartyType = ePartyType.businessDebtor;
  protected individualPartyType = ePartyType.individualDebtor;

  constructor(
    partyRepo: PartyRepositoryService,
    uiConfigurationService: UIConfigurationService,
    orderManager: OrderManagerService,
    validationService: ValidationService) {
    super(partyRepo, uiConfigurationService, orderManager, validationService);
  }

  protected override init(order: Order): void {
    super.init(order);
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return PartiesComponent.parseErrorsForValidationState(errors, order, party => true); //Include All Parties
  }

  public override getParties(): Party[] {
    return this.order.parties!;
  }

  override onSaving(): void {
    var partyToReplace = this.partiesListComponent.onSaving();
    if (partyToReplace) {
      this.replaceParty(partyToReplace!);
    }
  }
}
